(function (angular) {
	'use strict';

	angular.module('stateOfResidencyModalModule', [
		'coreModule'
	]);
})(window.angular);